import script from "./BookingAround.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingAround.vue?vue&type=script&setup=true&lang=js"

import "./BookingAround.vue?vue&type=style&index=0&id=4ac59cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac59cf0"]])

export default __exports__